import { PageHeader } from 'antd'
import React from 'react'
import JobCalendar from '../components/job/job-calendar'

class CalendarEvent extends React.Component {
  render() {
    return (
      <>
      <PageHeader title="ปฏิทินงานทั้งหมด"/>
      <div>ระบบจะแสดงรายการของทุกคนทั้งหมด</div>
       <JobCalendar/>
      </>
    )
  }
}


export default CalendarEvent
